import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Nav from "./Nav";
import Footer from "./Footer";
import StickyMobileCTA from "./StickyMobileCTA";
import { Toaster } from "./ui/sonner";
import { motion, useReducedMotion } from "framer-motion";

export default function Layout() {
  const location = useLocation();
  const reduced = useReducedMotion();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [location.pathname]);

  return (
    <div className="App relative">
      <Nav />
      <motion.main
        key={location.pathname}
        initial={reduced ? false : { opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
      >
        <Outlet />
      </motion.main>
      <Footer />
      <StickyMobileCTA />
      <Toaster
        position="top-center"
        toastOptions={{
          style: {
            background: "#1A1A1A",
            color: "#FAFAFA",
            border: "1px solid rgba(255,255,255,0.08)",
            fontFamily: "Manrope, sans-serif",
            borderRadius: "999px",
            padding: "12px 20px",
          },
        }}
      />
    </div>
  );
}
